export const CycleServiceError = {
	FieldPageExceedsPageCount: 'field page exceeds page count',
	CycleTemplateNameAlreadyExists: 'template name exists',
	NotifyCycleNoNotification: 'notification failed for one or more users',
	UnmatchingFieldType: 'unmatching field type',
	TriggerError: 'trigger error',
	UnMatchingStatus: 'unmatching status',
} as const;
export type CycleServiceError = (typeof CycleServiceError)[keyof typeof CycleServiceError] | keyof typeof CycleServiceError;
